var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useRef, useState } from 'react';
import { ButtonTertiary, cssColorValue, IconPublic, PopoverTrigger, Tooltip, TooltipTrigger, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { getDisplayName } from '../LanguageSelectionDialog/utils';
import { useS4XMastheadContext } from '../S4XMastheadProvider';
import { trackCat } from './constants';
import { flyoutTransitionMixin } from './FlyoutMenu/config';
var MobileTrigger = styled(ButtonTertiary)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  width: fit-content;\n"], ["\n  color: ", ";\n  width: fit-content;\n"])), cssColorValue('textBase'));
var DesktopTrigger = styled(ButtonTertiary)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  cursor: pointer;\n  &,\n  &:hover,\n  &:focus,\n  &:focus:after {\n    border-color: ", ";\n    color: ", ";\n  }\n"], ["\n  ", "\n  cursor: pointer;\n  &,\n  &:hover,\n  &:focus,\n  &:focus:after {\n    border-color: ", ";\n    color: ", ";\n  }\n"])), flyoutTransitionMixin('color', 'border-color'), function (props) { return props.theme.text; }, function (props) { return props.theme.text; });
var LanguageTooltip = function (_a) {
    var children = _a.children, tooltipText = _a.tooltipText;
    var _b = useState(false), enabled = _b[0], setEnabled = _b[1];
    var timer = useRef(null);
    var onMouseEnter = function () {
        timer.current = setTimeout(function () {
            setEnabled(true);
        }, 1000);
    };
    var onMouseLeave = function () {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        setEnabled(false);
    };
    return (React.createElement(TooltipTrigger, { overlay: enabled && React.createElement(Tooltip, null, tooltipText), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, placement: PopoverTrigger.bottom, onShow: function () { }, onHide: function () { } }, children));
};
export var NavBarLanguageItem = function (_a) {
    var container = _a.container, language = _a.language, languageSelectionEntry = _a.languageSelectionEntry, closeBackdrop = _a.closeBackdrop, _b = _a.trackingCategory, trackingCategory = _b === void 0 ? trackCat : _b;
    var InteractiveElement = useS4XMastheadContext().InteractiveElement;
    var tooltipText = languageSelectionEntry.fields.chooseLanguagePrompt;
    var label = languageSelectionEntry.fields.globeButtonAriaLabel;
    var dir = language.dir, locale = language.locale, marketSelectReturnToPath = language.marketSelectReturnToPath;
    var hrefQueryString = marketSelectReturnToPath
        ? "?returnToPath=".concat(encodeURIComponent(marketSelectReturnToPath))
        : '';
    var href = language.useCountryRegionPicker
        ? "https://www.spotify.com/select-your-country-region/".concat(hrefQueryString)
        : undefined;
    var onClick = useCallback(function () {
        if (!language.useCountryRegionPicker) {
            closeBackdrop === null || closeBackdrop === void 0 ? void 0 : closeBackdrop();
            language.onClick();
        }
    }, [closeBackdrop, language]);
    if (container === 'header') {
        return (React.createElement(LanguageTooltip, { tooltipText: tooltipText },
            React.createElement(InteractiveElement, { customComponent: DesktopTrigger, href: href, trackingCategory: trackingCategory, trackingLabel: "Language button", "aria-label": label, size: "small", "data-testid": "language-selection-trigger-desktop", dir: dir, iconOnly: IconPublic, onClick: onClick })));
    }
    return (React.createElement(InteractiveElement, { customComponent: MobileTrigger, "aria-label": label, "data-testid": "language-selection-trigger-mobile", dir: dir, href: href, iconLeading: IconPublic, condensedAll: true, size: "medium", trackingCategory: trackingCategory, trackingLabel: "Language button", onClick: onClick }, language.useCountryRegionPicker
        ? language.market
        : getDisplayName(locale)));
};
var templateObject_1, templateObject_2;
